module.exports = __webpack_public_path__ + "img/5E5049_CDC2BE_9C8E88_B7ACA4-256px.666b2d15.png";